import { render, staticRenderFns } from "./DuelStudent.vue?vue&type=template&id=60145e52&scoped=true"
import script from "./DuelStudent.vue?vue&type=script&lang=js"
export * from "./DuelStudent.vue?vue&type=script&lang=js"
import style0 from "./DuelStudent.vue?vue&type=style&index=0&id=60145e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60145e52",
  null
  
)

export default component.exports